import React, { forwardRef, useImperativeHandle } from 'react';
import {
  useForm,
  FormProvider,
  FieldValues,
  UseFormProps,
  SubmitHandler,
  SubmitErrorHandler,
  UseFormReturn,
} from 'react-hook-form';
// import { DevTool } from '@hookform/devtools';

interface ServiceFormProps<T extends FieldValues> extends Pick<UseFormProps<T>, 'mode' | 'shouldUnregister'> {
  externalValues?: UseFormProps<T>['defaultValues'];
  onSubmit: SubmitHandler<T>;
  onSubmitError?: SubmitErrorHandler<T>;
  className?: string;
  children?: React.ReactNode;
  disabled?: boolean;
}

const ServiceForm = forwardRef(
  <T extends FieldValues>(
    {
      onSubmit,
      onSubmitError,
      externalValues,
      mode,
      shouldUnregister,
      className,
      children,
      disabled,
    }: ServiceFormProps<T>,
    ref?: React.Ref<UseFormReturn<T, any, undefined>>,
  ) => {
    const methods = useForm<T>({ defaultValues: externalValues, mode, shouldUnregister: shouldUnregister ?? true });

    const { handleSubmit, reset } = methods;

    useImperativeHandle(ref, () => ({ ...methods }), [methods]);

    return (
      <FormProvider {...methods}>
        <form
          onSubmit={!disabled ? handleSubmit(onSubmit, onSubmitError) : undefined}
          onReset={() => reset()}
          className={className}
        >
          {children}
          {/* https://github.com/react-hook-form/devtools/issues/201 이슈로 warning 발생하여 주석 처리 */}
          {/* {env('ENV') === 'development' && <DevTool control={control} />} */}
        </form>
      </FormProvider>
    );
  },
);

export default ServiceForm;
